import singlePost from './community/singlePost/reducer';
import communityHome from './community/communityHome/reducer';
import editProfile from './user/editProfile/reducer';
import articleList from './articles/articleList/reducer';
import article from './articles/articleReducer';
import editorial from './tags/editorial/reducer';
import tags from './tags/shared/reducer';
import programs from './programs/reducer';
import home from './home/reducer';
import search from './search/shared/reducer';
import communityPosts from './community/communityPosts/reducer';
import local from './local/reducer';
import needsAssessmentReport from './needsAssessment/needsAssessmentReport/reducer';
import needsAssessmentList from './needsAssessment/needsAssessmentList/reducer';
import communityAbout from './community/communityAbout/reducer';
import tag from 'src/pages/tag/reducer';
import tagsList from './tagsList/reducer';

const pageReducers = {
  singlePost,
  communityHome,
  editProfile,
  articleList,
  article,
  editorial,
  tags,
  programs,
  home,
  search,
  communityPosts,
  local,
  needsAssessmentReport,
  needsAssessmentList,
  communityAbout,
  tag,
  tagsList,
};

export default pageReducers;
